import React from "react"
import PropTypes from "prop-types"
import { useIntl } from "gatsby-plugin-react-intl"
import styled from "styled-components"

import { Container, Row, Col } from "../components/Grid"
import BodyText from "../components/BodyText"
import Cta from "../components/Cta"
import Snippet from "../components/Snippet"

import { media, mixins } from "../styles"
import PrintSVG from "../images/icons/printer.inline.svg"

const Wrapper = styled.div`
  @media ${media.md} {
    background: ${({ theme }) => theme.greyLight};
  }
`
const Header = styled.div`
  background: ${({ theme }) => theme.greyLight};
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 0 45px;
  min-height: 225px;
  padding: 50px 0;
  text-align: center;

  h1 {
    ${mixins.title2}
    margin: 0;
  }

  @media ${media.md} {
    background: none;
    margin: 0;
  }

  @media ${media.xl} {
    margin-top: 20px;
    min-height: 315px;
  }

  @media print {
    min-height: 0 !important;
    padding-bottom: 0;
    text-align: left;
  }
`

const Content = styled.div`
  background: ${({ theme }) => theme.white};

  @media ${media.md} {
    margin: 0 0 55px;
    padding: 45px 40px 25px;
  }

  @media ${media.lg} {
    margin: 0 0 75px;
  }

  @media ${media.xl} {
    margin: 0 auto 105px;
    max-width: 1024px;
  }
`

const PrintIcon = styled.button`
  align-items: center;
  appearance: none;
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.sun};
  cursor: pointer;
  display: flex;
  float: right;
  margin: 0 5px 35px 35px;
  padding: 0;
  transition: color ${({ theme }) => theme.transitionTime};

  &:hover {
    color: ${({ theme }) => theme.spaceblue};
  }

  @media print {
    display: none;
  }

  > span {
    display: none;
    margin-left: 10px;
    ${mixins.copy5}

    @media ${media.lg} {
      display: block;
    }
  }
`

const Print = () => {
  const intl = useIntl()
  const handleClick = () => {
    window.print()
  }

  return (
    <PrintIcon
      onClick={() => handleClick()}
      title={intl.formatMessage({ id: "print" })}
    >
      <PrintSVG />
      <span>{intl.formatMessage({ id: "print" })}</span>
    </PrintIcon>
  )
}

const TextPage = ({ content, header }) => {
  return (
    <>
      <Container>
        <Wrapper>
          <Row>
            <Col xs="12" md="10" mdOffset="1" lg="8" lgOffset="2">
              <Header>
                <h1>{header}</h1>
              </Header>
            </Col>
          </Row>
          <Row>
            <Col xs="12" md="10" mdOffset="1">
              <Content>
                <BodyText>
                  <Print />
                  {content}
                </BodyText>
              </Content>
            </Col>
          </Row>
        </Wrapper>
      </Container>
      <Cta
        header={Snippet({
          id: "textpageCTA",
          field: "header",
        })}
        linkText={Snippet({
          id: "textpageCTA",
          field: "linkText",
        })}
        linkUrl={Snippet({
          id: "textpageCTA",
          field: "linkUrl",
        })}
      />
    </>
  )
}

TextPage.propTypes = {
  content: PropTypes.object.isRequired,
  header: PropTypes.string.isRequired,
}

export default TextPage
